import React from 'react'
import _ from 'common-tools/LodashHelper'
import { ReduxWrapper, compose } from 'common-data/datahelpers'

export const ActionStopBubbleClick = (onClick) => {
  return (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()

    if (_.isFunction(onClick) === true) {
      onClick(e)
    }
  }
}

export const ActionLinkPlain = ({ asDiv = false, children, stopBubbleClicks = true, className, onClick, ...rest }) => {
  return React.createElement(
    asDiv ? 'div' : 'span',
    {
      onClick: stopBubbleClicks ? ActionStopBubbleClick(onClick) : onClick
    },
    <a
      href='#'
      className={className}
      {...rest}
    >
      {children}
    </a>
  )
}

export const ActionLink = compose(
  ReduxWrapper([
  ], [
  ])
)(ActionLinkPlain)
